import { authHeader } from '../../constants/authenticationHeader';
import { baseSliceWithTags } from '../baseSlice';
import { addCandidate, toCandidatesPayload } from '../../utils/pipelineCandidates';
import destroy from '../apiService/destroy';
import form from '../apiService/form';
import list from '../apiService/list';

const projects = {};
projects.list = () => list('/rest/projects', 'project');
projects.form = () => form('/rest/projects', 'project');
projects.delete = () => destroy('/rest/projects/delete', 'project');

export const { useProjectaddCandidateMutation } = baseSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    projectaddCandidate: builder.mutation({
      async queryFn({ projectId, userId, stageId }, api, extraOptions, baseQuery) {
        const csrf = authHeader();
        const response = await baseQuery({
          url: '/rest/projects/get',
          method: 'get',
          params: { id: projectId },
          csrf,
        });
        if (response.error) return response;
        const project = response.data.data;
        return baseQuery({
          url: '/rest/projects/update',
          method: 'post',
          csrf,
          data: {
            id: project.id,
            projects_pipeline_stages_users: toCandidatesPayload(
              addCandidate(project.projects_pipeline_stages_users, {
                project_id: project.id,
                user_id: userId,
                pipeline_stage_id: stageId,
              }),
            ),
          },
        });
      },
      invalidatesTags: ['project'],
    }),
  }),
});

export default projects;
